import { IonButton, IonCol, IonGrid, IonIcon, IonItem, IonRow, isPlatform } from '@ionic/react';
import { chevronForward, chevronForwardOutline, informationCircleOutline } from 'ionicons/icons';

import moment from 'moment';
import QRCodeCanvas from 'qrcode.react';
import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import AddToWallet from '../../components/addToWallet';
import {
  FieldError,
  NormalText,
  SmallText,
  Spacer,
  StrongText,
  Subtitle,
  Title,
} from '../../components/common';
import Layout from '../../components/layout';
import Modal from '../../components/modal';
import Loading from '../../components/spinner';
import api from '../../lib/api';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import {
  checkBackgroundColor,
  forwardTo,
  isDefined,
  isEmptyObject,
  isWebConfig,
  validateProfileData,
} from '../../lib/utils';
import {
  getFaq,
  getGiftCards,
  getLoyaltyInfo,
  getProfile,
  getRewards,
  getTransactionHistory,
  getVouchers,
  setModal,
} from '../../store/actions';
import KioskCodeGenerator from '../../components/kioskCode';

import './index.css';
import VoucherCodeInput from '../../components/voucherCodeInput';
import UnlockRewardItems from '../../components/unlockRewardItems';
import MilestoneRewards from '../../components/milestoneRewards';
import ValidateButton from '../../components/validateButton';
import Slider, { Slide } from '../../components/slider';

const VoucherListItem = ({ reward, id, className, action, __, reason }) => {
  return (
    <div onClick={action ? () => action(id) : null} className="voucher-list-wrapper" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div>
        <StrongText className="block">{reward.name}</StrongText>
        <SmallText>
          {reason && reason != '' ? `${reason}. ` : ''}
          {`${__('Expires')} ${moment(reward.expiry_date, 'YYYY/MM/DD').format('DD/MM/YY')}`}
        </SmallText>
      </div>
      <IonIcon style={{ height: '18px', width: '18px' }} icon={chevronForward} />
    </div>
  );
};
export const VoucherItem = ({ reward, id, className, action, __, onlyImage }) => {
  return (
    <div onClick={action ? () => action(id) : null} className='voucher-wrapper'>
      <div className='voucher-overlay'>
        <img className={'voucher-image' + (className ? ' ' + className : '')} src={reward.image} />

      </div>
      {!onlyImage && (
        <div className="voucher-description">
          <NormalText>{__(reward.name)}</NormalText>
          <NormalText>{`${__('Expires:')} ${moment(reward.expiry_date, 'YYYY/MM/DD').format('DD/MM/YYYY')}`}</NormalText>
        </div>
      )}
    </div>
  );
};
export const getLabel = (item) => {
  let label = '';
  const defaultDescriptors = [
    {
      bl_id: '-1',
      label: 'Referral Bonus',
    },
    {
      bl_id: '-2',
      label: 'Sign up Bonus',
    },
    {
      bl_id: '-3',
      label: 'Refunded points',
    },
  ];
  const historyDescriptors = getConfig().history_descriptors || defaultDescriptors;

  const descriptors = historyDescriptors.filter((el) => el.bl_id === item.business_location_id);
  if (descriptors.length > 0) {
    label = descriptors[0].label;
  } else {
    let isPoints = item.is_points;
    let isStamps = item.is_stamps;
    let isVouchers = item.is_vouchers;
    let subLabel = '';
    if (Math.abs(item.stamp_power) === 1) {
      subLabel = `${isPoints ? 'Point' : isStamps ? 'Stamp' : isVouchers ? 'Voucher' : ''}`;
    } else if (item.stamp_power !== 1) {
      subLabel = `${isPoints ? 'Points' : isStamps ? 'Stamps' : isVouchers ? 'Vouchers' : ''}`;
    }
    if (item.stamp_power < 0) {
      label = `${subLabel} Redeemed`;
    } else if (item.stamp_power > 0) {
      label = `${subLabel} Earned`;
    }
  }
  return label;
};
class Loyalty extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: null,
      loyaltyFaqModalOpened: false,
      voucherCode: '',
      selectedVoucher: null,
      formErrors: {
        voucherCode: '',
      },
      stampCards: [],
      stampCardModalOpen: false,
      stampCardData: null,
      keyboardIsVisible: false,
      groupedVouchers: [],
      logo_image: this.props.clientProfile.logo_image || '',
      logo_image_light:
        this.props.clientProfile.logo_image_light || this.props.clientProfile.logo_image || '',
      logoColor: 'dark'

    };
    this.groupedVouchersRef = {}

    this.formConfig = {
      voucherCode: { type: 'text', required: true },
    };
  }
  handleSlideChange = (index, group) => {
    const { __ } = this.props
    const wrapper = this.groupedVouchersRef?.[group]?.current
    const data = this.state.groupedVouchers?.[group]?.[index]
    if (wrapper) {
      wrapper.querySelector('.normal-text[data-attr="name"]').textContent = data.reward.name
      wrapper.querySelector('.normal-text[data-attr="expiry"]').textContent = `${__(`Expires`)} ${moment(data.reward.expiry_date, 'YYYY/MM/DD').format('DD/MM/YY')}`
    }
  }

  getVoucherGroups = (data) => {
    return Object.values(
      data.reduce((acc, item) => {
        const key = item.reward.id;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {})
    );

  }
  async componentDidMount() {

    const styles = this.props.clientStyles?.colors?.['--okx-loyalty-card-background'];
    if (styles) {
      let logoColor = checkBackgroundColor(styles) || 'dark';
      this.setState({ logoColor });
    }
    this.props.dispatch(getRewards());
    this.props.dispatch(getTransactionHistory());
    this.props.dispatch(getLoyaltyInfo());
    this.props.dispatch(getGiftCards());

    const config = await api.getFrontEndAppConfig();

    const stampsPosition =
      config?.stamp_cards_json?.map((el) => Array(el.stamps_required).fill({})) || [];
    for (let i = 0; i < stampsPosition.length; i++) {
      for (let j = 0; j < stampsPosition[i].length; j++) {
        stampsPosition[i][j] = {
          top: this.getRandomNumber(-3, 3),
          left: this.getRandomNumber(-3, 3),
          rotate: this.getRandomNumber(-90, 90),
        };
      }
    }
    this.props.dispatch(getFaq());
    this.setState({ stampCards: config?.stamp_cards_json || [], stampsPosition });
    if (this.props?.location?.state?.openVoucherModal) {
      setTimeout(() => {
        this.viewVoucher(this.props.location.state.openVoucherModal);
      }, 500);
    }
    this.setState({ groupedVouchers: this.getVoucherGroups(this.props.vouchers.filter(voucher => voucher.voucher_type == 'voucher')) }, () => {
      this.state.groupedVouchers.map((group, index) => {
        const rewardId = index;
        if (!this.groupedVouchersRef[rewardId]) {
          this.groupedVouchersRef[rewardId] = createRef();
        }
      })
    })
  }

  viewVoucher = (id) => {
    const { vouchers } = this.props;
    forwardTo('/voucher', { qr_code: this.props.profile.qr_code, voucher: vouchers.find((v) => v.id === id) })
  };

  redeemVoucher = () => {
    const { voucherCode } = this.state;
    if (voucherCode !== '') {
    }
  };
  getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }
  getNumberOfRowsAndColumns(stampNumber) {
    let data = {};
    if (stampNumber % 3 == 0) {
      data.columns = 'repeat(3,70px)';
      data.rows = '70px';
    }
    else if (stampNumber % 5 !== 0) {
      data.columns = 'repeat(4,50px)';
      data.rows = '50px';
    } else {
      data.columns = 'repeat(5,40px)';
      data.rows = '40px';
    }
    return data;
  }
  getStampImage = (url) => {
    if (url.startsWith('http') || url.startsWith('data:')) {
      return url

    } else {
      return `data:image/svg+xml;base64,${url}`
    }
  }
  onRefreshHandler = (e) => {
    setTimeout(() => {
      this.props.dispatch(getProfile());
      this.props.dispatch(getTransactionHistory());
      this.props.dispatch(getRewards());
      this.props.dispatch(getVouchers());

      e.target.complete();
    }, 2000);
  };
  render() {
    const {
      __,
      profile,
      screenName,
      transactionHistory,
      faq,
      vouchers,
      qr_code,
      rewards,
      giftCards
    } = this.props;
    const { loyaltyFaqModalOpened, voucherCode, selectedVoucher, keyboardIsVisible, logo_image_light, logo_image, logoColor } = this.state;

    const valid = validateProfileData(profile).isValid;
    let voucherRes = vouchers || [];

    const { hasAddToAppleWallet, hasAddToGoogleWallet } = getConfig().flags;
    const points_value_percentage =
      isDefined(getConfig().api_config) && isDefined(getConfig().api_config.points_value_percentage)
        ? getConfig().api_config.points_value_percentage
        : 0;
    const numberOfStamps = profile?.stamp_cards_json?.reduce((sum, item) => sum + item.stamp_balance, 0) || 0
    return (
      <Loading >
        <Layout
          withRefresher={true}
          onRefreshHandler={this.onRefreshHandler}
          color="transparent"
          noPadding={true}
          showHamburger
        >
          <div className={`scrollable-y ${keyboardIsVisible ? 'keyboard-is-visible' : ''}`}>
            <Title className={'loyalty-header-title'} style={{ paddingLeft: 'var(--ion-padding-page)' }}>{__('Your loyalty card')}</Title>
            {!getConfig().flags.loyaltyCardWithImage ? <div className='loyalty-header-with-image-wrapper'>
              <ValidateButton />
              <IonGrid className='loyalty-header'>
                <IonRow>
                  <IonCol>
                    <img src={logoColor === 'white' ? logo_image_light : logo_image} />
                  </IonCol>
                  <IonCol className='righted'>
                    {Basket.calculatePointsAppliedPrice(profile.available_balance) > 0 && !getConfig().flags.removeLoyaltyPointsWorth && (
                      <Title className='bold'>
                        {Basket.formatPrice(Basket.calculatePointsAppliedPrice(profile.available_balance))}
                      </Title>
                    )}
                  </IonCol>
                </IonRow>
                <IonRow class='loyalty-card-image'>
                  <img src={getConfig().general.loyaltyCardImage} />

                </IonRow>
                <IonRow>
                  <IonCol>
                    <Subtitle style={{ textAlign: 'left', wordBreak: 'break-word' }} className="bold">{screenName}</Subtitle>
                    <div className="loyalty-header-groups">
                      {profile?.group_tags && profile.group_tags.map((tag) => (
                        <SmallText>{tag}</SmallText>
                      ))}
                    </div>
                  </IonCol>
                  <IonCol style={{ alignSelf: 'start' }} className='righted'>
                    {numberOfStamps > 0 &&
                      <Subtitle className="bold ">{`${numberOfStamps} ${__(`${numberOfStamps == 1 ? 'stamp' : 'stamps'}`)}`}</Subtitle>

                    }
                  </IonCol>

                </IonRow>

                {!getConfig().flags.removeQRCodeOnLoyalty && (
                  <>
                    {isDefined(profile.qr_code) && profile.qr_code !== '' ? (
                      <>

                        <IonRow className='centered qr-code-wrapper'>
                          <div className="qr-code">
                            <div className={`${getConfig().flags.showConsumerID && profile.consumer_id ? 'qr-holder-with-consumer-id' : ''}  qr-holder`}>
                              <QRCodeCanvas value={profile.qr_code} size={isWebConfig() ? 126 : 110} />
                              {getConfig().flags.showConsumerID && profile.consumer_id && <StrongText>{profile.consumer_id}</StrongText>}
                            </div>
                          </div>
                        </IonRow>
                        <Spacer size={5} />
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                )}

                {getConfig().flags.hasKioskCodeGenerator && (
                    <IonRow>
                      <KioskCodeGenerator />
                    </IonRow>
                )}

                {(points_value_percentage > 0 && profile.available_balance > 0) &&
                  <IonRow>

                    <IonCol>
                      <Subtitle style={{ display: 'flex', alignItems: 'center', textAlign: 'start' }}>{`${profile.available_balance} ${__('points')}`}
                        <IonIcon
                          style={{ marginLeft: '5px', cursor: 'pointer' }}
                          onClick={() => {
                            this.setState({ loyaltyFaqModalOpened: true });
                          }}
                          icon={informationCircleOutline}
                        />

                      </Subtitle>
                      {!getConfig().flags.removeLoyaltyPointsWorth &&
                        <SmallText>{`${__('worth')} ${Basket.formatPrice(Basket.calculatePointsAppliedPrice(profile.available_balance))}`}</SmallText>

                      }
                    </IonCol>
                    <IonCol className='righted'>
                      <Subtitle>{`${__('Earn')} ${points_value_percentage} ${__('points')}`}</Subtitle>
                      <SmallText>{`${__('every')} ${Basket.formatPrice(1).replace('.00', '')} ${__('spent')}`}</SmallText>
                    </IonCol>
                  </IonRow>

                }

              </IonGrid>
              {isDefined(profile.qr_code) &&
                profile.qr_code !== '' &&
                (hasAddToAppleWallet || hasAddToGoogleWallet) ? (
                <div className='centered'>
                  <AddToWallet />
                </div>

              ) : null}

            </div> :

              <>
                <div className="loyalty-header" style={{ backgroundImage: `url(${getConfig().general.loyaltyCardImage})` }} >
                  <div className="loyalty-header-name">
                    <Subtitle className="bold loyalty-name">{screenName}</Subtitle>
                    <div className="loyalty-header-groups">
                      {profile?.group_tags && profile.group_tags.map((tag) => (
                        <SmallText>{tag}</SmallText>
                      ))}
                    </div>
                  </div>
                  <div className="loyalty-header-content">
                    <div>
                      {points_value_percentage == 0 && profile.available_balance == 0 ? (
                        <div></div>
                      ) : (
                        <div>
                          <Subtitle className="loyalty-points lowercase">
                            {profile.available_balance?.toLocaleString()} {__('pts')}{' '}
                            <IonIcon
                              onClick={() => {
                                this.setState({ loyaltyFaqModalOpened: true });
                              }}
                              icon={informationCircleOutline}
                              className='text-color'
                            />
                          </Subtitle>
                          {Basket.calculatePointsAppliedPrice(profile.available_balance) > 0 && !getConfig().flags.removeLoyaltyPointsWorth && (
                            <SmallText className="loyalty-points-value">
                              {`${__('worth')} ${Basket.formatPrice(Basket.calculatePointsAppliedPrice(profile.available_balance))}`}
                            </SmallText>
                          )}

                        </div>
                      )}

                      <div>
                        <SmallText className="block is-uppercase">{__('Member since')}</SmallText>
                        <SmallText className="uppercase ">{moment(profile.created_at).format('MM/YY')}</SmallText>
                      </div>
                    </div>

                    <div style={{ flexDirection: 'column' }}>
                      {!getConfig().flags.removeQRCodeOnLoyalty && (
                        <>
                          {isDefined(profile.qr_code) && profile.qr_code !== '' ? (
                            <div className='qr-code-wrapper' style={{ alignSelf: 'center' }}>

                              <div className="qr-code">
                                <div className={`${getConfig().flags.showConsumerID && profile.consumer_id ? 'qr-holder-with-consumer-id' : ''}  qr-holder`}>
                                  <QRCodeCanvas value={profile.qr_code} size={isWebConfig() ? 126 : 110} />
                                  {getConfig().flags.showConsumerID && profile.consumer_id && <StrongText style={{ width: '100%' }} className='block'>{profile.consumer_id}</StrongText>}
                                </div>
                              </div>
                            </div>

                          ) : (
                            <></>
                          )}
                        </>
                      )}
                      {isDefined(profile.qr_code) &&
                        profile.qr_code !== '' &&
                        (hasAddToAppleWallet || hasAddToGoogleWallet) ? (
                        <>
                          <AddToWallet />
                          <Spacer size={2} />
                        </>
                      ) : null}
                      {!isWebConfig() && getConfig().flags.hasKioskCodeGenerator && (
                        <>
                          {' '}
                          <KioskCodeGenerator />
                          <Spacer size={2} />
                        </>
                      )}
                    </div>
                  </div>
                  {isWebConfig() && getConfig().flags.hasKioskCodeGenerator && (
                    <>
                      <Spacer size={2} /> <KioskCodeGenerator />
                    </>
                  )}
                </div>
                <div
                  onClick={() => {
                    !valid && this.props.dispatch(setModal('isVerfiedModalOpen', true));
                  }}
                  className={`loyalty-validation-wrapper ${!valid && 'invalid'}`}
                >
                  <NormalText>{valid ? __('Account verified') : __('Account not verified')}</NormalText>
                </div>
              </>
            }


            {this.state.stampCards.length > 0 && (
              <div className="stamps-content">
                <Title >
                  {__('Your stamp cards')}
                </Title>

                {this.state.stampCards
                  .filter((el) => el.is_global && el.is_published)
                  .map((stampCard, stampIndex) => {
                    return (
                      <>
                        <div
                          key={stampIndex}
                          style={{
                            backgroundColor: stampCard?.additional_config?.background_color ?? stampCard?.background_color,
                            color: stampCard?.additional_config?.text_color ?? stampCard?.text_color,
                          }}
                          className="stamps-wrapper box-wrapper">
                          {stampCard?.additional_config?.banner_image &&
                            <img src={`${stampCard?.additional_config?.banner_image}`} className='stamps-box-image' />

                          }
                          <div className="stamps-box-header">
                            <div>
                              <Subtitle
                                style={{ "--custom-text-color": stampCard?.additional_config?.text_color ?? stampCard?.text_color }}
                                className='bold text-to-update'>{__(stampCard?.title)}</Subtitle>
                              <NormalText
                                style={{ "--custom-text-color": stampCard?.additional_config?.text_color ?? stampCard?.text_color }}
                                className=''>{__(stampCard?.description)}</NormalText>
                            </div>
                            <IonIcon
                              className='text-color'
                              onClick={() => {
                                this.setState({
                                  stampCardModalOpen: true,
                                  stampCardData: stampCard,
                                });
                              }}
                              style={{ "--custom-text-color": stampCard?.additional_config?.text_color ?? stampCard?.text_color }}
                              icon={informationCircleOutline}
                            />
                          </div>

                          <div
                            className="stamps-box"
                            style={{
                              gridTemplateColumns: this.getNumberOfRowsAndColumns(
                                stampCard?.stamps_required,
                              ).columns,
                              gridAutoRows: this.getNumberOfRowsAndColumns(stampCard?.stamps_required)
                                .rows,
                            }}
                          >
                            {Array(stampCard?.stamps_required)
                              .fill(null)
                              .map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className={
                                      index <
                                        (profile?.stamp_cards_json || []).filter(
                                          (item) => item.id === stampCard.id,
                                        )[0]?.stamp_balance
                                        ? 'stamp-photo redeemable-stamp-photo'
                                        : 'stamp-photo locked-stamp-photo'
                                    }

                                    style={{
                                      backgroundColor: stampCard?.additional_config?.placeholder_color
                                    }}
                                  >
                                    {(stampCard?.additional_config?.stamp_placeholder_svg || stampCard?.stamp_bg_svg) &&
                                      <img
                                        alt="stamp"
                                        className='placeholder-stamp'

                                        src={this.getStampImage(`${stampCard?.additional_config?.stamp_placeholder_svg ?? stampCard?.stamp_bg_svg}`)}
                                      />
                                    }
                                    {index <
                                      (profile?.stamp_cards_json || []).filter(
                                        (item) => item.id === stampCard.id,
                                      )[0]?.stamp_balance &&
                                      <img
                                        alt="stamp "
                                        style={{
                                          ...(stampCard?.additional_config?.removeStampRotation ? {} : {
                                            transform: `rotate(${this.state.stampsPosition[stampIndex][index].rotate}deg)`,
                                            top: this.state.stampsPosition[stampIndex][index].top,
                                            left: this.state.stampsPosition[stampIndex][index].left,
                                          })
                                        }}
                                        src={this.getStampImage(`${stampCard?.additional_config?.stamp_svg ?? stampCard?.stamp_svg}`)}
                                      />
                                    }

                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            )}

            {getConfig().flags.hasUnlockRewards && rewards.length > 0 && (
              <>
                <div className="loyalty-content  loyalty-slider">
                  <UnlockRewardItems available_balance={profile.available_balance} rewards={rewards} qr_code={qr_code} __={__} />
                  {voucherRes.filter((voucher) => voucher.voucher_type == 'unlock_reward').length > 0 &&
                    <div className="box-wrapper">
                      {voucherRes &&
                        voucherRes
                          .filter((voucher) => voucher.voucher_type == 'unlock_reward')
                          .map((voucher, index) => {
                            return <VoucherListItem key={'vc-' + index} {...voucher} __={__} action={this.viewVoucher} />;
                          })}
                    </div>
                  }
                </div>


              </>
            )}
            {getConfig().flags.hasMilestoneRewards && rewards.length > 0 && (
              <>
                <div className="loyalty-content">
                  <MilestoneRewards lifetime_balance={profile.milestone_balance} rewards={rewards} qr_code={qr_code} __={__} />
                  {voucherRes.filter((voucher) => voucher.voucher_type == 'milestone').length > 0 &&
                    <div className="box-wrapper">
                      {voucherRes &&
                        voucherRes
                          .filter((voucher) => voucher.voucher_type == 'milestone')
                          .map((voucher, index) => {
                            return <VoucherListItem key={'vc-' + index} {...voucher} __={__} action={this.viewVoucher} />;
                          })}
                    </div>
                  }
                </div>

              </>
            )}
            {getConfig().flags.hasVouchers &&
              <>
                {voucherRes.length > 0 &&
                  <div className="loyalty-vouchers-wrapper">
                    <FieldError className="field-error" value={__(this.state.formErrors.voucherCode)} />
                    <>
                      <Title >{__('Your vouchers')}</Title>
                      {this.state.groupedVouchers.map((group, groupId) => (
                        <div className='voucher-wrapper' ref={this.groupedVouchersRef[groupId]}>
                          <Slider
                            onSlideChange={(index) => this.handleSlideChange(index, groupId)}
                            settings={{
                              slidesPerView: group.length == 1 ? 1 : 1.1,
                              spaceBetween: 8,
                              slidesOffsetBefore: 0,
                              centeredSlides: false,
                            }}
                          >
                            {group.map((voucher, index) => (
                              <Slide className={`${group.length == 1 ? 'single-slide' : ''}`} onClick={() => this.viewVoucher(voucher.id)}>
                                <div className='voucher-overlay pointer'>
                                  <img className='voucher-image' src={voucher.reward.image} />
                                  <NormalText className='voucher-counter'>{`${index + 1}/${group.length} ${__('available')}`}</NormalText>
                                </div>

                              </Slide>
                            ))}
                          </Slider>
                          <div className='voucher-description'>
                            <NormalText data-attr='name'>{__('voucher.reward.name')}</NormalText>
                            <NormalText data-attr='expiry'>{`${__('Expires')} `}</NormalText>
                          </div>
                        </div>


                      ))
                      }
                    </>
                  </div>

                }

                <VoucherCodeInput showButton voucherAddedModalOpen={this.props.voucherAddedModalOpen} />

              </>
            }
            {giftCards.length > 0 &&
              <div className='loyalty-content'>
                <Title>{__('Gift cards')}</Title>

                <div className='box-wrapper'>
                  {giftCards.map(card => {
                    const isExpired = moment(card.expiry_date, 'DD/MM/YYYY').isBefore(moment())
                    return (
                      <IonItem lines='none' onClick={() => forwardTo('/gift-card', { card, isExpired })}>
                        <div>
                          <StrongText className='block'>{card.value_remaining_str}</StrongText>
                          <Spacer size={0} />
                          <SmallText className={`${isExpired ? 'danger-color' : ""}`}>{`${isExpired ? __('Expired:') : __('Expires:')} ${card.expiry_date}`}</SmallText>
                        </div>
                        <IonIcon style={{ height: '18px', width: '18px' }} slot='end' icon={chevronForwardOutline} />
                      </IonItem>
                    )
                  }
                  )}
                </div>
              </div>
            }
            <div className="loyalty-history">
              {transactionHistory.length > 0 && (
                <>
                  <Title>
                    {__('Your latest activity')}
                  </Title>
                  <div className="transactions-wrapper box-wrapper">
                    {transactionHistory.slice(0, 3).map((el, index) => {
                      return (
                        <div key={index} className="small-padding ">
                          <IonRow key={index}>
                            <IonCol
                              size="8"
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                              }}
                            >
                              <StrongText className=" block ">{__(getLabel(el))}</StrongText>
                              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <SmallText style={{ marginRight: '4px' }}>{Basket.getDate(el.transaction_date.replace('Z', '')).format(`ddd DD MMM YYYY [${__('at')}]`)}</SmallText>
                                <SmallText>{Basket.getDate(el.transaction_date.replace('Z', '')).format(' h:mm a')}</SmallText>
                              </div>
                            </IonCol>
                            <IonCol
                              ize="4"
                              style={{
                                display: 'grid',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                              }}
                            >
                              <div className="transaction-points-wrapper">

                                {el.is_vouchers ? <NormalText >
                                  {__(el.reason_balance)}

                                </NormalText> :
                                  <Subtitle className={el.is_vouchers ? 'bold' : el.stamp_power < 0 ? 'bold danger-color' : 'bold success-color'}>
                                    <>
                                      {el.stamp_power < 0 ? '-' : '+'}
                                      {Math.abs(el.stamp_power)}
                                    </>
                                  </Subtitle>
                                }
                                {el.is_stamps ? (
                                  <SmallText>{Math.abs(el.stamp_power) == 1 ? __('stamp') : __('stamps')}</SmallText>
                                ) : el.is_points ? (
                                  <SmallText>{Math.abs(el.stamp_power) == 1 ? __('point') : __('points')}</SmallText>
                                ) : null}
                              </div>
                            </IonCol>
                          </IonRow>
                        </div>
                      );
                    })}

                    {transactionHistory.length > 3 && (
                      <div className="small-padding ">

                        <IonButton

                          className="link "
                          color="secondary"
                          expand="block"
                          onClick={() => forwardTo('/history')}
                        >
                          {__('Show all activity')}
                        </IonButton>
                      </div>

                    )}
                  </div>
                </>
              )}
              <Spacer size={2} />

            </div>
          </div>
        </Layout>
        <Modal
          className="loyalty-faq-modal"
          isOpen={this.state.stampCardModalOpen}
          onDidDismiss={() => {
            this.setState({ stampCardModalOpen: false });
          }}
        >
          <div className="lefted">
            <Title className='modal-title'>{this.state.stampCardData?.title}</Title>
            <Spacer size={2} />
            <NormalText
              dangerouslySetInnerHTML={{
                __html: this.state.stampCardData?.stamp_content,
              }}
            ></NormalText>
          </div>
        </Modal>
        <Modal
          className="loyalty-faq-modal"
          isOpen={loyaltyFaqModalOpened}
          onDidDismiss={() => {
            this.setState({ loyaltyFaqModalOpened: false });
          }}
        >
          <div className="lefted">
            <Subtitle className='modal-title'>{__('Loyalty Info')}</Subtitle>
            <div dangerouslySetInnerHTML={{ __html: this.props.loyaltyInfo }}></div>
          </div>{' '}
        </Modal>


        <Modal
          className="voucher-modal"
          isOpen={selectedVoucher !== null}
          onDidDismiss={() => {
            this.setState({ selectedVoucher: null });
            this.props.history.replace({ state: {} });
          }}
        >
          {selectedVoucher && selectedVoucher.reward ? (
            <div >
              <Title className='modal-title'>{__('Voucher details')}</Title>
              <Spacer size={2} />
              <VoucherItem  {...selectedVoucher} __={__} />
              <Spacer size={2} />

              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {isDefined(qr_code) ? (
                  <div className="qr-code-wrapper" style={{ display: 'flex' }}>
                    <QRCodeCanvas value={qr_code} size={160} />
                  </div>
                ) : (
                  <div className="noQrCode" style={{ textAlign: 'center' }}>
                    <h5>{__('NO QR CODE')}</h5>
                  </div>
                )}
              </div>


              <Spacer size={5} />
              <div className="voucher-modal-content">
                <StrongText className="block text-to-update">{__('Voucher info')}</StrongText>
                <Spacer size={2} />

                <div></div>
                <div className='voucher-description-modal'>
                  {selectedVoucher.reward.description ? <div dangerouslySetInnerHTML={{ __html: selectedVoucher.reward.description }} /> : null}

                </div>
              </div>
            </div>
          ) : null}
        </Modal>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  const { profile, giftCards } = state.profile;
  const { rewards } = state.restaurants;
  const { history } = state.orders;
  const { clientProfile, clientStyles, voucherAddedModalOpen } = state.common;
  let screenName = '';
  if (
    (isDefined(profile) && !isEmptyObject(profile) && profile.first_name) ||
    profile.last_name ||
    (profile.first_name && profile.last_name)
  ) {
    screenName = `${profile.first_name} ${profile.last_name}`;
  }
  return {
    screenName,
    profile,
    rewards: rewards || [],
    transactionHistory: history || [],
    faq: state.common.faq || null,
    vouchers: state.profile.vouchers || [],
    qr_code: state.profile.profile.qr_code,
    clientProfile,
    loyaltyInfo: state.common.loyaltyInfo,
    giftCards: giftCards || [],
    voucherAddedModalOpen,
    clientStyles,



  };
};

export default connect(stateToProps)(withRouter(withTranslation(Loyalty)));
